<template>
  <CCard>
    <CButton
      v-show="booleanAvalaibleTimes"
      type="button"
      title="Horários Disponíveis"
      class="btn_voltar"
      @click="voltar"
      :class="classBtn"
      ><CIcon name="cil-arrow-left"></CIcon>
    </CButton>
    <fieldset v-show="!booleanAvalaibleTimes">
      <CSelect
        v-show="showSelectProfessional"
        :value.sync="selectedProfessional"
        :options="professionals"
        v-model="selectedProfessional"
        placeholder="Profissionais"
        @change="selectOptionsFilter"
        class="btn-filter-horarios"
      >
      </CSelect>
      <CSelect
        class="btn-filter-horarios"
        v-show="showSelectSala"
        :value.sync="selectedRoom"
        :options="rooms"
        v-model="selectedRoom"
        placeholder="Salas"
        @change="selectOptionsFilter"
      >
      </CSelect>
    </fieldset>

    <CCardBody>
      <FullCalendar
        :options="calendarOptions"
        @select="handleSelect"
        :class="classObject"
        v-show="!booleanAvalaibleTimes"
      />
      <div v-show="this.typeName != 'Profissional'">
        <CButton
          v-if="!booleanAvalaibleTimes"
          type="button"
          title="Horários Disponíveis"
          class="button-avalaible-times"
          @click="handleAvalaibleTimes"
          :class="classBtn"
          >Horários Disponíveis
        </CButton>
      </div>

      <!-- <CButton
        v-show="btnBack"
        type="button"
        title="Voltar"
        class="btn-back"
        @click="handleAvalaibleTimes"
      >
        Voltar
      </CButton> -->
    </CCardBody>
    <avalaibleTimes v-show="booleanAvalaibleTimes" />
  </CCard>
</template>

<script>
import "@fullcalendar/core/vdom"; // solves problem with Vite
import FullCalendar, { getDateMeta } from "@fullcalendar/vue";
import dayGridPlugin from "@fullcalendar/daygrid";
import timeGridPlugin from "@fullcalendar/timegrid";
import interactionPlugin from "@fullcalendar/interaction";
import esLocale from "@fullcalendar/core/locales/pt-br";
import listPlugin from "@fullcalendar/list";
import moment from "moment";

import avalaibleTimes from "../components/calendar/avalaibleTimes.vue";

export default {
  components: {
    FullCalendar,
    avalaibleTimes, // make the <FullCalendar> tag available
  },
  data() {
    return {
      btnAvailableTimes: false,
      btnBack: false,
      booleanAvalaibleTimes: false,
      template: null,
      url_base: "",
      showSelectProfessional: false,
      showSelectSala: true,
      calendarOptions: {
        plugins: [dayGridPlugin, interactionPlugin, timeGridPlugin, listPlugin],
        headerToolbar: {
          left: "prev,next today",
          center: localStorage.getItem("type_name") != "Profissional" ? "title" : "",
          right: "timeGridDay,timeGridWeek,dayGridMonth,listWeek",
        },

        locale: esLocale,
        initialView:
          localStorage.getItem("type_name") == "Profissional"
            ? "listWeek"
            : "dayGridMonth",
        selectable: true,

        allDaySlot: false,
        slotMinTime: "08:00:00",
        slotMaxTime: "21:00:00",
        droppable: true,
        businessHours: {
          // days of week. an array of zero-based day of week integers (0=Sunday)
          daysOfWeek: [1, 2, 3, 4, 5], // Monday - Thursday
          startTime: "08:00", // a start time (10am in this example)
          endTime: "21:00", // an end time (6pm in this example)
        },
        dayMaxEvents: false,
        views: {
          timeGrid: {
            dayMaxEventRows: 8,
            // adjust to 6 only for timeGridWeek/timeGridDay
          },
        },
        dayPopoverFormat: [{}],
        events: [{}],
        select: this.handleSelect,
        click: this.handleAvalaibleTimes,
        datesSet: this.changeDate,
        eventClick: this.editar,
        eventMouseEnter: this.mostrarProps,
        eventMouseLeave: this.escoderProps,
        eventContent: this.props,

        dateClick: function (info) {},
      },
      selectedProfessional: null,
      selectedRoom: null,
      professionals: [],
      rooms: [],
      classObject: {
        active: false,
      },
      classBtn: {
        activeAvalaibleTimes: false,
      },
      eventos: [],
      typeName: "",
      startAtual:"",
      endAtual: ""
    };
  },

  methods: {
    voltar() {
      this.booleanAvalaibleTimes = !this.booleanAvalaibleTimes;
    },
      changeDate(info) {
    console.log({ info });
    const startDate = moment(info.startStr).format("YYYY-MM-DD");
    console.log({ startDate })
    const endDate = moment(info.endStr).format("YYYY-MM-DD");
    console.log({ endDate })

    // Verifica se a data de início mudou antes de fazer a requisição
    if (this.startAtual !== startDate) {
      this.startAtual = startDate; // Atualiza startAtual com o novo valor
      this.endAtual = endDate;     // Atualiza endAtual com o novo valor
      this.registrarDados(startDate, endDate);
    }
    },
    handleAvalaibleTimes(info) {
      this.booleanAvalaibleTimes = true;
    },
    hideElement(element) {
      element.style.display = "none";
    },
    handleSelect(info) {
      if (new Date(info.startStr) < new Date()) {
      } else {
        this.$router.push({
          name: "Consultas",
          query: { type: "a" },
          params: {
            data: info.startStr,
            voltar: "calendario/listar",
          },
        });
      }
    },

    editar(info) {
      let type = localStorage.getItem("type_name");
      let id = localStorage.getItem("id");
      if (type == "Profissional") {
        this.$router.push({
          name: "Consultas",
          query: { id: info.event.extendedProps.id, type: "b" },
          params: {
            voltar: "calendario/listar",
          },
        });
      } else {
        this.$router.push({
          name: "Consultas",
          query: { id: info.event.extendedProps.id, type: "b" },
          params: {
            voltar: "calendario/listar",
          },
        });
      }
    },

    handleEventClick(info) {},
    capitalizeFullName(fullName) {
      const names = fullName.toLowerCase().split(" ");
      const capitalizedNames = names.map(
        (name) => name.charAt(0).toUpperCase() + name.slice(1)
      );
      return capitalizedNames.join(" ");
    },

    registrarDados(startDate, endDate) {
      this.setup()
      const url = `${this.url_base}?start=${startDate}&end=${endDate}`;
      console.log({ url })
      this.$http
        .get(url)
        .then(({ body }) => {
          const formatarData = (data, hora) =>
            moment.utc(data).format("YYYY-MM-DD") + "T" + hora;

          this.eventos = body.map(
            ({ id, patient, date_at, hour_at, name, phone, sala }) => ({
              title: `${this.capitalizeFullName(patient)} | sala: ${sala}`,
              start: formatarData(date_at, hour_at),
              end: formatarData(date_at, hour_at),
              extendedProps: {
                id,
                profissional: name,
                telefone: phone,
                sala: sala,
              },
              description: "Consulta",
              color: "blue",
            })
          );

          // Atualiza os eventos no calendário
          this.calendarOptions.events = this.eventos;
        })
        .catch((error) => {
          console.error("Erro ao buscar eventos:", error);
        });
    },

    listOfProfessionals() {
      this.professionals.push({
        label: "Profissionais",
        value: null,
      });

      this.$http
        .get(`${process.env.VUE_APP_API_BASE_URL}lista-profissional-calendar`)
        .then((res) => res.json())
        .then((res) => {
          res.forEach((item) => {
            console.log({ item });
            this.professionals.push({
              label: item.name,
              value: item.name,
            });
          });
        });
    },
    listOfRooms() {
      this.rooms.push({
        label: "Salas",
        value: null,
      });
      this.$http
        .get(`${process.env.VUE_APP_API_BASE_URL}lista-salas-calendar`)
        .then((res) => res.json())
        .then((res) => {
          res.forEach((item) => {
            this.rooms.push({
              label: `Sala: ${item.sala}`,
              value: item.sala,
            });
          });
        });
    },
    selectOptionsFilter() {
      if (this.selectedRoom !== null || this.selectedProfessional !== null) {
        this.calendarOptions.events = this.eventos.filter((x) => {
          if (this.selectedRoom !== null && this.selectedProfessional !== null) {
            return (
              x.extendedProps.sala == this.selectedRoom &&
              x.extendedProps.profissional == this.selectedProfessional
            );
          } else if (this.selectedRoom !== null) {
            return x.extendedProps.sala == this.selectedRoom;
          } else if (this.selectedProfessional !== null) {
            return x.extendedProps.profissional == this.selectedProfessional;
          }
          return true;
        });
      } else {
        this.calendarOptions.events = this.eventos;
      }
    },
    setup(){
       let type = localStorage.getItem("type_name");
    this.typeName = type;
    if (type == "Profissional") {
      this.template = "listWeek";
      this.calendarOptions.initialView = "listWeek";
    } else {
      this.template = "dayGridMonth";
    }
    if (
      type == "Administrador" ||
      type == "Administrador-master" ||
      type == "Recepcionista"
    ) {
      this.showSelectProfessional = true;
      this.btnAvailableTimes = true;
      this.url_base = `${process.env.VUE_APP_API_BASE_URL}consulta/calendar`;
    } else {
      this.showSelectProfessional = false;
      this.btnAvailableTimes = false;
      let id = localStorage.getItem("id");
      this.url_base = `${process.env.VUE_APP_API_BASE_URL}consulta/calendar-user/${id}`;
    }
    }
  },
  mounted() {
   this.setup()
    this.listOfProfessionals();
    // this.registrarDados();

    this.listOfRooms();
  },
};
</script>

<style scoped>
@media screen and (max-width: 550px) {
  .fc .fc-toolbar.fc-header-toolbar {
    display: grid !important;
  }
  .fc .fc-toolbar.fc-header-toolbar .fc-toolbar-chunk {
    padding-bottom: 10px;
  }
}

@media (max-width: 1900px) {
  .button-avalaible-times {
    height: 4.5vh;
    margin-top: 0.3vw;
    margin-left: -5vw;
    background-color: #2c3e50;
    color: #fff;
    position: absolute;
    width: 12vw;
    display: block;
    top: 1.1vw;
    left: 56vw;
  }
  .btn-back {
    height: 4vh;
    background-color: #2c3e50;
    color: #fff;
    width: 7vw;
    display: block;
    position: absolute;
    margin: -0.2vw 69vw;
  }
}
@media (min-width: 1900px) {
  .button-avalaible-times {
    background-color: #2c3e50;
    color: #fff;
    position: absolute;
    width: 12vw;
    display: block;
    top: 1.35rem;
    right: 18rem;
  }
  .btn-back {
    height: 3.5vh;
    background-color: #2c3e50;
    color: #fff;
    width: 7vw;
    display: block;
    position: absolute;
    margin: -0.2vw 72vw;
  }
}
.button-avalaible-times:hover {
  background-color: #151e27;
  color: #fff;
}
.display-none-body-calendar {
  display: none;
}
.display-block-body-calendar {
  display: block;
}
.div-body-calendar {
  margin: 13vh 1px;
  display: block;
  border: 1px solid rgb(220, 220, 220);
  position: absolute;
  width: 1159px;
  height: 78vh;
}
fieldset .form-control {
  width: 7vw !important;
  background-color: #2c3e50 !important;
  color: #fff;
  height: 35px;
}
fieldset .form-control:focus {
  width: 7vw;
  background-color: #2c3e50;
  color: #fff;
  height: 35px;
}
fieldset {
  display: grid;
  grid-template-columns: 1fr 1fr;
  width: 11vw;
  position: absolute;
  margin: 21px 11vw;
}
.active {
  display: none !important;
}
.btn-filter-horarios .form-control {
  background: #2c3e50;
  color: white;
}
.activeAvalaibleTimes {
  margin: -0.9vh 9vw;
  height: 4.5vh;
}
.btn_voltar {
  position: absolute;
  top: 0;
  right: 0;
}
</style>
